import {Injectable} from '@angular/core';
import {first} from 'rxjs';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {BcGqlService, IGQLFormDisplayField, IGQLResponse} from '@betterchains/bc-gql';
import {environment} from '../../environments/environment';

const api = environment.api

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    private gql: BcGqlService,
    private http: HttpClient
  ) {
  }

  LoadForm(id:number) {
    return this.http.get<any>(`${api}/forms/builder/data/${id}?token=${localStorage.getItem('apiToken')}`)
  }

  SaveForm(id:number, data:any) {
    return this.http.post<any>(`${api}/forms/builder/data/${id}?token=${localStorage.getItem('apiToken')}`, data)
  }

  GetDisplayFields(formId: number, chainId: number, branchId: number) {
    return new Promise<IGQLFormDisplayField[]>((resolve, reject) => {
      this.gql.query(
        //language=gql
        `
          query GetDisplayFields($formId: Int, $chainId: Int, $branchId: Int) {
            forms {
              display_fields(form_id: $formId, chain_id: $chainId, branch_id: $branchId) {
                chain_id
                branch_id
                form_id
                field_id
              }
            }
          }
        `,
        {formId, chainId, branchId}
      ).pipe(first()).subscribe({
        next: (r: HttpResponse<IGQLResponse<{forms:{display_fields:IGQLFormDisplayField[]}}>>) => {
          resolve(r.body.data.forms.display_fields)
        },
        error: e => reject(e)
      })
    })
  }

  SetDisplayFields(formId: number, chainId: number, branchId: number, fieldIds: number[]) {
    return new Promise<void>((resolve, reject) => {
      this.gql.query(
        //language=gql
        `
      mutation SetDisplayFields($formId: Int, $chainId: Int, $branchId: Int, $fieldIds: [Int]) {
        forms {
          display_fields(chain_id: $chainId, branch_id: $branchId, form_id: $formId, field_ids: $fieldIds)
        }
      }
      `,
        {formId, chainId, branchId, fieldIds}
      ).pipe(first()).subscribe({next: () => resolve(), error: () => reject()})
    })
  }

}
